import { atom } from 'jotai'
import { match } from 'ts-pattern'

export type SelectionScreen =
  | 'selection'
  | 'cancel'
  | 'cancel-confirm'
  | 'renew'
  | 'upgrade'

export const modalScreenAtom = atom<SelectionScreen>('selection')

export const modalTitleAtom = atom<string>(get => {
  const screen = get(modalScreenAtom)

  return match(screen)
    .with('selection', () => 'Edit schedule')
    .with('cancel', 'cancel-confirm', () => 'Cancel schedule')
    .with('renew', () => 'Renew schedule')
    .with('upgrade', () => 'Upgrade schedule')
    .exhaustive()
})
